import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useFormatter, useTranslations } from "next-intl";
import { UiLegacy } from "@silvertours/front-legacy-shared";
import { RatingGroupItemCriterion, RatingGroupList } from "./Reviews.styles";
var ratingFormatOptions = {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1
};
var useRatingGroupTitle = function(organizers, hostName) {
    var t = useTranslations("features.trustLegacy.feedback.reviewItem.ratingGroupTitle");
    return function(groupName) {
        switch(groupName){
            case "site":
                return t("site", {
                    host: hostName
                });
            case "organizers":
                return t("organizers", {
                    organizers: organizers
                });
            default:
                return t("rentalCompanies");
        }
    };
};
var RatingGroups = function(param) {
    var ratingGroups = param.ratingGroups, providerQuote = param.providerQuote, host = param.host;
    var format = useFormatter();
    var t = useTranslations("features.trustLegacy.feedback.reviewItem");
    var getGroupTitle = useRatingGroupTitle(providerQuote.organizers, host);
    return /*#__PURE__*/ _jsx(RatingGroupList, {
        children: ratingGroups.map(function(param) {
            var groupType = param.type, items = param.items;
            return /*#__PURE__*/ _jsxs("li", {
                children: [
                    /*#__PURE__*/ _jsx("b", {
                        children: getGroupTitle(groupType)
                    }),
                    items.map(function(param) {
                        var rating = param.rating, ratingType = param.type;
                        return /*#__PURE__*/ _jsxs("p", {
                            children: [
                                /*#__PURE__*/ _jsx(RatingGroupItemCriterion, {
                                    children: t("ratingTitle.".concat(ratingType))
                                }),
                                /*#__PURE__*/ _jsx(UiLegacy.Rating, {
                                    value: rating
                                }),
                                /*#__PURE__*/ _jsx("b", {
                                    children: format.number(rating, ratingFormatOptions)
                                }),
                                " / 5"
                            ]
                        }, ratingType);
                    })
                ]
            }, groupType);
        })
    });
};
export { RatingGroups };
